import React, { useEffect, useState } from "react";
import Layout from "../layouts/Layout";
import { DecodeToken } from "../../DecodeToken";
import { Oval } from "react-loader-spinner";
import SweetAlert from "sweetalert-react";
import HeaderNomResto from "../HeaderNomResto";
import { Navigate } from "react-router-dom";
import {
  rechercherentreprises,
  rechercherentreprisespartenaires,
  recherchersiteparentreprise,
} from "../../services/entreprises/entrepriseRequest";
import { Autocomplete, TextField } from "@mui/material";
import PackagePlatModal from "./PackagePlatModal";
import {
  rechercherlistepackages,
  supprimerpackage,
  activerpackageobligatoire,
} from "../../services/packages/PackageRequest";
import { recherchertouslesRestaurants } from "../../services/restaurants/RestaurantRequest";
import Paginate from "../pagination";

const libelleTypeRepas = {
  ENTREE: "Entrée",
  PLAT: "Plat de résistance",
  DESSERT: "Dessert",
  BOISSON: "Boisson",
};

function ListePackagePlat() {
  const [listePackages, setlistePackages] = useState([]);
  const [listeEntreprise, setListeEntreprise] = useState([]);
  const [entrepriseSelected, setEntrepriseSelected] = useState(null);
  const [listeSite, setListeSite] = useState([]);
  const [siteSelected, setSiteSelected] = useState(null);
  const [listeRestaurant, setListeRestaurant] = useState([]);
  const [restaurantSelected, setRestaurantSelected] = useState(null);
  const [infoPackage, setInfoPackage] = useState({});
  const [loading, setloading] = useState(false);
  const [modeCombaisonChoisi, setModeCombaisonChoisi] = useState("TYPE_REPAS");
  const [pageActive, setPageActive] = useState(1);
  const [totalElement, setTotalElement] = useState(0);
  const [totalElementByPage, setTotalElementByPage] = useState(0);
  const [param, setParam] = useState("");
  const [showSweetAlert, setShowSweetAlert] = useState(false);
  const [packageIdToDelete, setPackageIdToDelete] = useState("");
  const [showConfirmObligatoire, setShowConfirmObligatoire] = useState(false);
  const [loadingObligatoire, setLoadingObligatoire] = useState(false);
  const [errorMessageObligatoire, setErrorMessageObligatoire] = useState("");
  const [combinaisonEstObligatoire, setCombinaisonEstObligatoire] =
    useState(false);

  const afficherPackages = (
    currentPage = pageActive,
    recherche = param,
    restaurantId = restaurantSelected ? restaurantSelected.id : 0,
    entrepriseId = entrepriseSelected ? entrepriseSelected.id : "",
    siteId = siteSelected ? siteSelected.id : ""
  ) => {
    setloading(true);
    rechercherlistepackages(
      currentPage - 1,
      recherche,
      restaurantId,
      entrepriseId,
      siteId
    )
      .then((res) => {
        setloading(false);
        setlistePackages(res.data.donnee.liste);
        setTotalElement(res.data.donnee.totalElements);
        setTotalElementByPage(res.data.donnee.numberOfElements);
        setCombinaisonEstObligatoire(res.data.donnee.combinaisonIsRequired);
      })
      .catch(() => {
        setloading(false);
      });
  };

  const afficherEntreprise = () => {
    if (DecodeToken().profil === "ROLE_ADMIN") {
      rechercherentreprises()
        .then((response) => {
          setListeEntreprise(response.data.donnee);
        })
        .catch((error) => {
          console.log("ERROR", error);
        });
    } else {
      rechercherentreprisespartenaires().then((res) => {
        setListeEntreprise(res.data.donnee);
      });
    }
  };

  const afficherRestaurant = () => {
    recherchertouslesRestaurants().then((response) => {
      setListeRestaurant(response.data.donnee);
    });
  };

  const afficherSites = (entrepriseId) => {
    if (!entrepriseId) {
      setListeSite([]);
      return;
    }
    recherchersiteparentreprise(entrepriseId).then((res) => {
      setListeSite(res.data.donnee);
    });
  };

  const handleChoixEntreprise = (value) => {
    setEntrepriseSelected(value);
    setSiteSelected(null);
    afficherSites(value ? value.id : null);
    setPageActive(1);
    afficherPackages(
      1,
      param,
      restaurantSelected ? restaurantSelected.id : 0,
      value ? value.id : "",
      ""
    );
  };

  const handleChoixSite = (value) => {
    setSiteSelected(value);
    setPageActive(1);
    afficherPackages(
      1,
      param,
      restaurantSelected ? restaurantSelected.id : 0,
      entrepriseSelected ? entrepriseSelected.id : "",
      value ? value.id : ""
    );
  };

  const handleChoixRestaurant = (value) => {
    setRestaurantSelected(value);
    setPageActive(1);
    afficherPackages(
      1,
      param,
      value ? value.id : "",
      entrepriseSelected ? entrepriseSelected.id : "",
      siteSelected ? siteSelected.id : ""
    );
  };

  const handleSearchPackage = (recherche) => {
    setParam(recherche);
    setPageActive(1);
    afficherPackages(1, recherche);
  };

  const handlePageChange = (pageNumber) => {
    setPageActive(pageNumber);
    afficherPackages(pageNumber, param);
  };

  const ouvrirCreationPackage = (mode) => {
    setInfoPackage({});
    setModeCombaisonChoisi(mode);
    document.getElementById("ouvrirPackagePlatModal").click();
  };

  const modifierPackage = (item) => {
    setInfoPackage(item);
    document.getElementById("ouvrirPackagePlatModal").click();
  };

  const handleDeletePackage = (id) => {
    setPackageIdToDelete(id);
    setShowSweetAlert(true);
  };

  const confirmerSuppressionPackage = () => {
    setShowSweetAlert(false);
    setloading(true);
    supprimerpackage(packageIdToDelete)
      .then(() => {
        setloading(false);
        afficherPackages();
      })
      .catch(() => {
        setloading(false);
      });
  };

  const ouvrirConfirmationObligatoire = () => {
    if (DecodeToken().profil === "ROLE_ADMIN" && !restaurantSelected) {
      setErrorMessageObligatoire(
        "Veuillez choisir un restaurant avant d'activer cette contrainte"
      );
      return;
    }
    setErrorMessageObligatoire("");
    setShowConfirmObligatoire(true);
  };

  const confirmerPackageObligatoire = () => {
    setShowConfirmObligatoire(false);
    setLoadingObligatoire(true);
    activerpackageobligatoire(restaurantSelected ? restaurantSelected.id : 0)
      .then(() => {
        setLoadingObligatoire(false);
        afficherPackages();
      })
      .catch(() => {
        setLoadingObligatoire(false);
      });
  };

  useEffect(() => {
    afficherPackages();
    afficherEntreprise();
    if (DecodeToken().profil === "ROLE_ADMIN") {
      afficherRestaurant();
    }
  }, []);

  DecodeToken().profil !== "ROLE_RESTAURATRICE" &&
    DecodeToken().profil !== "ROLE_COMPTABLE" &&
    DecodeToken().profil !== "ROLE_ADMIN" && <Navigate to="/login" replace />;

  const rowlistePackages = listePackages.map((item, index) => (
    <div className="col-md-4 mb-3" key={index}>
      <div className="card position-relative">
        <div className="card-body">
          <div className="d-flex align-items-start justify-content-between">
            <h6 className="card-title">
              {item.nom && item.nom !== "" ? item.nom : "Package sans nom"}
            </h6>
            {(DecodeToken().profil === "ROLE_RESTAURATRICE" ||
              DecodeToken().profil === "ROLE_ADMIN") && (
              <div>
                <i
                  onClick={() => modifierPackage(item)}
                  className="fa fa-pencil text-danger mx-1 p-2 rounded-circle fw-bold edit cursor"
                ></i>
                <i
                  onClick={() => handleDeletePackage(item.id)}
                  className="fa fa-trash-alt text-danger p-2 rounded-circle fw-bold delete cursor"
                ></i>
              </div>
            )}
          </div>

          <p className="card-text fw-bold mb-2" style={{ color: "#CE5D1D" }}>
            {item.prix} F CFA
          </p>

          <div className="mb-2">
            {item.listeCombinaisonFormuler &&
              item.listeCombinaisonFormuler.map((composant, i) => (
                <span
                  key={i}
                  className="badge me-1 mb-1"
                  style={{ backgroundColor: "#f9f1ed", color: "#000" }}
                >
                  {composant.quantite} x{" "}
                  {composant.typeRepas
                    ? libelleTypeRepas[composant.typeRepas] ??
                      composant.typeRepas
                    : composant.repas
                    ? composant.repas.designation
                    : composant.repasId}
                </span>
              ))}
          </div>

          <div
            className="card text-wrap d-flex align-items-center p-2"
            style={{ backgroundColor: "#f9f1ed" }}
          >
            <p
              className="card-text text-wrap fw-bold mb-0"
              style={{ fontSize: 14 }}
            >
              {item.entreprise != null && item.entreprise}
              {item.site != null ? ` - ${item.site}` : ""}
              {DecodeToken().profil === "ROLE_ADMIN" && item.restaurant != null
                ? ` (${item.restaurant})`
                : ""}
            </p>
          </div>
        </div>
      </div>
    </div>
  ));

  return (
    <Layout>
      <div className="row justify-content-between">
        <div
          className="col-12"
          style={{ height: "135vh", overflowY: "hidden", overflow: "scroll" }}
        >
          <HeaderNomResto />
          <div className="d-flex align-items-center justify-content-between mt-4 mb-4">
            <p className="fw-bold">Liste des packages disponibles</p>
            {DecodeToken().profil === "ROLE_RESTAURATRICE" ||
            DecodeToken().profil === "ROLE_ADMIN" ? (
              <div className="d-flex align-items-center gap-2">
                {(DecodeToken().profil !== "ROLE_ADMIN" || restaurantSelected) &&
                  (loadingObligatoire ? (
                    <Oval width={30} height={30} color="#CE5D1D" visible />
                  ) : (
                    <div>
                      <button
                        className="btn"
                        style={{
                          border: "1px solid #CE5D1D",
                          color: "#CE5D1D",
                        }}
                        type="button"
                        onClick={ouvrirConfirmationObligatoire}
                      >
                        {combinaisonEstObligatoire
                          ? "Désactiver la contrainte"
                          : "Rendre le package obligatoire"}
                      </button>
                      {errorMessageObligatoire !== "" && (
                        <p
                          className="text-danger mb-0 mt-1"
                          style={{ fontSize: 12 }}
                        >
                          {errorMessageObligatoire}
                        </p>
                      )}
                    </div>
                  ))}
                <div className="dropdown">
                  <button
                    className="btn text-white dropdown-toggle"
                    style={{ backgroundColor: "#CE5D1D" }}
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa fa-plus me-2"></i>
                    Créer un package
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => ouvrirCreationPackage("TYPE_REPAS")}
                      >
                        Par type de repas
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => ouvrirCreationPackage("REPAS")}
                      >
                        Par plat précis
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            ) : null}
          </div>

          <div className="d-flex justify-content-between">
            <div className="input-group mb-3" style={{ width: "30%" }}>
              <div className="input-group-text bg-white">
                <i className="fa fa-search text-secondary"></i>
              </div>
              <input
                type="search"
                placeholder="Recherche..."
                onChange={(e) => handleSearchPackage(e.target.value)}
                className="form-control loginborderleft"
              />
            </div>
            <div className="d-flex gap-2">
              {DecodeToken().profil === "ROLE_ADMIN" ? (
                <Autocomplete
                  disablePortal
                  options={listeRestaurant}
                  getOptionLabel={(option) => option.nom ?? option}
                  value={restaurantSelected}
                  onChange={(event, value) => handleChoixRestaurant(value)}
                  sx={{ width: 220 }}
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className="bg-white"
                      label="Restaurant"
                    />
                  )}
                />
              ) : null}
              <Autocomplete
                disablePortal
                options={listeEntreprise}
                getOptionLabel={(option) => option.raisonSociale ?? option}
                value={entrepriseSelected}
                onChange={(event, value) => handleChoixEntreprise(value)}
                sx={{ width: 220 }}
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="bg-white"
                    label="Entreprise"
                  />
                )}
              />
              <Autocomplete
                disablePortal
                options={listeSite}
                getOptionLabel={(option) => option.nom ?? option}
                value={siteSelected}
                onChange={(event, value) => handleChoixSite(value)}
                disabled={!entrepriseSelected}
                sx={{ width: 220 }}
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="bg-white"
                    label="Site de l'entreprise"
                  />
                )}
              />
            </div>
          </div>

          <div className="row gx-2">
            {loading ? (
              <div className="d-flex mt-5 justify-content-center">
                <Oval
                  width={50}
                  height={50}
                  color="#CE5D1D"
                  visible={loading}
                />
              </div>
            ) : listePackages.length === 0 ? (
              <p className="text-center text-secondary mt-5">
                Aucun package disponible
              </p>
            ) : (
              rowlistePackages
            )}
          </div>

          {!loading && listePackages.length !== 0 && (
            <div className="d-flex justify-content-center mt-3">
              <Paginate
                pageActive={pageActive}
                handlePageChange={handlePageChange}
                nbreElementParPage={totalElementByPage}
                nbreTotalElmentPage={totalElement}
              />
            </div>
          )}
        </div>
      </div>

      <button
        id="ouvrirPackagePlatModal"
        data-bs-target="#packagePlatModal"
        data-bs-toggle="modal"
        hidden
      ></button>

      <PackagePlatModal
        infoPackage={infoPackage}
        actualiserListe={afficherPackages}
        modeCombaisonChoisi={modeCombaisonChoisi}
        restaurantSelected={restaurantSelected}
      />

      <SweetAlert
        show={showSweetAlert}
        title="Confirmer la suppression"
        text="Cette action est irréversible"
        showCancelButton
        onConfirm={confirmerSuppressionPackage}
        onCancel={() => setShowSweetAlert(false)}
        onEscapeKey={() => setShowSweetAlert(false)}
        onOutsideClick={() => setShowSweetAlert(false)}
      />

      <SweetAlert
        show={showConfirmObligatoire}
        title={
          combinaisonEstObligatoire
            ? "Désactiver la contrainte"
            : "Rendre le package obligatoire"
        }
        text={
          combinaisonEstObligatoire
            ? "Voulez-vous vraiment désactiver cette contrainte sur tous les packages ? Le choix d'un package ne sera plus obligatoire lors de la commande."
            : "Voulez-vous vraiment activer cette contrainte sur tous les packages ? Le choix d'un package deviendra obligatoire lors de la commande."
        }
        showCancelButton
        onConfirm={confirmerPackageObligatoire}
        onCancel={() => setShowConfirmObligatoire(false)}
        onEscapeKey={() => setShowConfirmObligatoire(false)}
        onOutsideClick={() => setShowConfirmObligatoire(false)}
      />
    </Layout>
  );
}

export default ListePackagePlat;
